import graphqlClient from '@/graphql/graphql-client';
import { toScalarListVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  TaskManagerCommentsDocument,
  type TaskManagerCommentsQuery,
} from '@/graphql/generated/graphql';

export type TaskCommentRecord = NonNullable<
  NonNullable<TaskManagerCommentsQuery['getTaskComments']>['items']
>[number];
export type GetTaskCommentsResponse = TaskManagerCommentsQuery;

export const useGetTaskComments = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { taskId: 'TaskId' });
  return useQuery({
    queryKey: ['task-comments', variables],
    queryFn: () => graphqlClient.request(TaskManagerCommentsDocument, variables),
  });
};

export const requestTaskComments = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { taskId: 'TaskId' });
  return graphqlClient.request(TaskManagerCommentsDocument, variables);
};

export const GET_TASK_COMMENTS_QUERY = TaskManagerCommentsDocument;
